import { BrokerCarrier } from '@api/Trinium/Endpoints/Broker/types';
import { Leg } from '@api/Trinium/Endpoints/Leg/types';
import { SalesPerson } from '@api/Trinium/Endpoints/Salepeople/types';
import { ExtendedDriver, ExtendedTractor } from '@hooks/useDriverTractors.types';

/**
 * Schema of a selected object in the Driver Dropdown component.
 */
export interface AssignedDriver {
	/** The selected Driver or Carrier or Salesperson */
	driver?: ExtendedDriver | BrokerCarrier | SalesPerson | null;
	/** The selected Tractor, when applicable */
	tractorId?: string | null;
}

/**
 * Mapping method to utilize the driver information on the Leg API for display
 * of the input without requiring going to the Driver API for additional info.
 * This is used for formik when showing the selected Driver, and the list is not
 * populated with the Driver API until required/opened.
 */
export function mapLegToDriverForm(leg?: Leg): AssignedDriver | null {
	if (!leg || !leg.drv) return null;

	if (leg.drv.type === 'B') {
		return {
			driver: {
				id: leg.drvId,
				name: leg.drv.name
			} as BrokerCarrier
		};
	} else {
		return {
			driver: {
				id: leg.drvId,
				name: leg.drv.name,
				tractorId: leg.tractorId,
				tractors: [] as ExtendedTractor[]
			} as ExtendedDriver,
			tractorId: leg.tractorId
		};
	}
}
